<template>
  <PdfPresentation :pdf="Product.pdf_path" ref="OpenPdfModal" />
  <ContactUsModal ref="OpenContactUsModal" />
  <v-container class="container-main mt-15" :fluid="$vuetify.display.mdAndDown ? true : false">
    <v-row justify="center" v-if="Product">
      <v-col cols="12" sm="11" md="11" lg="11">

        <v-row justify="space-between">
          <v-col cols="12" sm="12" md="8" class="pb-0">
            <h5 class="categorie-text">
              {{ Categorie[`name_${$vuetify.locale.current}`] }}
            </h5>
          </v-col>
        </v-row>

        <v-row justify="space-between">
          <v-col cols="12" sm="12" md="7" lg="8">
            <h2 class="product-title-text mb-8">
              {{ Product[`name_${$vuetify.locale.current}`] }}
            </h2>
          </v-col>

          <v-col cols="12" sm="12" md="5" lg="4" class="px-0">
            <v-card color="#0C0C0C" flat class="pa-4 card-price-details">
              <v-row class="ma-0" justify="space-between">

                <v-col cols="5" sm="5" md="5" lg="5" align-self="center" class="pa-0"
                  style="line-height: normal; text-wrap: nowrap; white-space: nowrap;"
                  v-if="Product.ID_price_type != 2 && get_price_type.length > 0 && Product.price != undefined">
                  <span :class="Product.price.toString().length > 6 ? 'price-text-small' : 'price-text'"
                    class="price-text" v-if="Product.ID_price_type != 2">
                    €<span style="color: #F6F2E6;">{{ Product.price ? Product.price.toLocaleString('ru-RU') :
                      Product.price }}</span>
                  </span>
                  <div class="price-subtext" v-if="Product.ID_price_type == 1">
                    {{ get_price_type.filter(p => p.ID == 1)[0]['name_' + $vuetify.locale.current] }}
                  </div>
                </v-col>

                <v-col cols="6" sm="6" md="6" lg="6" v-if="Product.ID_price_type == 2 && get_price_type.length > 0"
                  align-self="start" class="pa-0" style="line-height: normal; text-wrap: nowrap;">
                  <span class="price-text-3">
                    <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0 3.0625C0 1.61275 1.17525 0.4375 2.625 0.4375H18.375C19.8247 0.4375 21 1.61275 21 3.0625V13.5625C21 15.0122 19.8247 16.1875 18.375 16.1875H15.0938C14.6806 16.1875 14.2916 16.382 14.0437 16.7125L11.55 20.0375C11.025 20.7375 9.975 20.7375 9.45 20.0375L6.95625 16.7125C6.70838 16.382 6.31937 16.1875 5.90625 16.1875H2.625C1.17525 16.1875 0 15.0122 0 13.5625V3.0625ZM4.59375 4.375C4.23131 4.375 3.9375 4.66881 3.9375 5.03125C3.9375 5.39369 4.23131 5.6875 4.59375 5.6875H16.4062C16.7687 5.6875 17.0625 5.39369 17.0625 5.03125C17.0625 4.66881 16.7687 4.375 16.4062 4.375H4.59375ZM4.59375 7.65625C4.23131 7.65625 3.9375 7.95006 3.9375 8.3125C3.9375 8.67494 4.23131 8.96875 4.59375 8.96875H16.4062C16.7687 8.96875 17.0625 8.67494 17.0625 8.3125C17.0625 7.95006 16.7687 7.65625 16.4062 7.65625H4.59375ZM4.59375 10.9375C4.23131 10.9375 3.9375 11.2313 3.9375 11.5937C3.9375 11.9562 4.23131 12.25 4.59375 12.25H11.1562C11.5187 12.25 11.8125 11.9562 11.8125 11.5937C11.8125 11.2313 11.5187 10.9375 11.1562 10.9375H4.59375Z"
                        fill="#9A9A9B" />
                    </svg>
                    <span style="color: #F6F2E6; vertical-align: super;" class="ml-1">
                      {{ get_price_type.filter(p => p.ID == 2)[0]['name_' + $vuetify.locale.current] }}
                    </span>
                  </span>
                </v-col>


                <v-col :cols="Product.ID_price_type == 2 ? '6' : '7'" align-self="center" class="pa-0"
                  style="text-align: end;">
                  <span class="location-text">
                    <v-icon color="#9A9A9B">mdi-map-marker</v-icon>
                    {{ Product[`location_${$vuetify.locale.current}`] }}
                  </span>
                </v-col>
              </v-row>
              <v-row class="mx-0 mt-4 mb-3" justify="space-between">
                <span class="building-subtext">
                  {{ t("$vuetify.real_estate_single.Product_details.building_company") }}:
                </span>
              </v-row>
              <v-row class="ma-0" justify="space-between">
                <span class="pl-4 building-text">
                  <svg width="16" height="14" class="mr-1" viewBox="0 0 16 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.4476 12.9229H14.3991V5.38345C14.3991 5.09779 14.2867 4.82384 14.0867 4.62185C13.8867 4.41986 13.6154 4.30638 13.3326 4.30638H10.3996C10.3289 4.30638 10.2611 4.33475 10.2111 4.38525C10.1611 4.43574 10.133 4.50423 10.133 4.57565V12.9229H9.06651V1.10277C9.06828 0.935008 9.03222 0.769035 8.96109 0.617419C8.88995 0.465803 8.78559 0.332519 8.6559 0.227656C8.47913 0.0884698 8.26343 0.00906928 8.03943 0.000731198C7.81543 -0.00760689 7.59453 0.0555413 7.40809 0.181207L2.07553 3.76785C1.92925 3.86641 1.80937 3.99998 1.72656 4.15666C1.64376 4.31333 1.6006 4.48826 1.60094 4.66585V12.9229H0.552424C0.414622 12.9209 0.281161 12.9716 0.178888 13.0649C0.0766152 13.1582 0.0131188 13.2871 0.00117166 13.4258C-0.00367158 13.4995 0.00653453 13.5733 0.031156 13.6428C0.0557775 13.7124 0.0942884 13.776 0.144297 13.8299C0.194305 13.8837 0.254743 13.9266 0.321856 13.9559C0.388969 13.9851 0.461324 14.0002 0.534427 14H15.4656C15.5387 14.0002 15.611 13.9851 15.6781 13.9559C15.7453 13.9266 15.8057 13.8837 15.8557 13.8299C15.9057 13.776 15.9442 13.7124 15.9688 13.6428C15.9935 13.5733 16.0037 13.4995 15.9988 13.4258C15.9869 13.2871 15.9234 13.1582 15.8211 13.0649C15.7188 12.9716 15.5854 12.9209 15.4476 12.9229ZM4.53384 11.3073C4.534 11.3812 4.51913 11.4542 4.49015 11.522C4.46117 11.5898 4.4187 11.6508 4.36538 11.7013C4.31206 11.7518 4.24902 11.7907 4.18019 11.8156C4.11136 11.8404 4.0382 11.8508 3.96526 11.8459C3.82784 11.8338 3.70006 11.7696 3.60767 11.6661C3.51527 11.5627 3.46513 11.4278 3.46733 11.2885V10.2484C3.46545 10.1093 3.51573 9.97462 3.60808 9.87136C3.70043 9.76811 3.82802 9.70394 3.96526 9.69172C4.0382 9.68683 4.11136 9.69714 4.18019 9.722C4.24902 9.74687 4.31206 9.78576 4.36538 9.83627C4.4187 9.88677 4.46117 9.94781 4.49015 10.0156C4.51913 10.0834 4.534 10.1564 4.53384 10.2303V11.3073ZM4.53384 7.53759C4.534 7.61141 4.51913 7.68448 4.49015 7.75226C4.46117 7.82004 4.4187 7.88108 4.36538 7.93158C4.31206 7.98208 4.24902 8.02098 4.18019 8.04584C4.11136 8.07071 4.0382 8.08101 3.96526 8.07612C3.8279 8.06389 3.70022 7.99963 3.60785 7.89623C3.51548 7.79284 3.46528 7.65798 3.46733 7.51874V6.47869C3.46545 6.33957 3.51573 6.20487 3.60808 6.10162C3.70043 5.99837 3.82802 5.9342 3.96526 5.92198C4.0382 5.91709 4.11136 5.9274 4.18019 5.95226C4.24902 5.97713 4.31206 6.01602 4.36538 6.06653C4.4187 6.11703 4.46117 6.17807 4.49015 6.24584C4.51913 6.31362 4.534 6.38669 4.53384 6.46052V7.53759ZM7.20012 11.3073C7.20028 11.3812 7.18541 11.4542 7.15643 11.522C7.12745 11.5898 7.08498 11.6508 7.03165 11.7013C6.97833 11.7518 6.9153 11.7907 6.84647 11.8156C6.77764 11.8404 6.70448 11.8508 6.63153 11.8459C6.49435 11.8338 6.36677 11.7698 6.2744 11.6666C6.18204 11.5635 6.13174 11.4289 6.13361 11.2898V10.2484C6.1319 10.1094 6.18225 9.9749 6.27458 9.87179C6.36692 9.76868 6.49441 9.70461 6.63153 9.6924C6.70448 9.68751 6.77764 9.69781 6.84647 9.72268C6.9153 9.74754 6.97833 9.78644 7.03165 9.83694C7.08498 9.88744 7.12745 9.94848 7.15643 10.0163C7.18541 10.084 7.20028 10.1571 7.20012 10.2309V11.3073ZM7.20012 7.53759C7.20028 7.61141 7.18541 7.68448 7.15643 7.75226C7.12745 7.82004 7.08498 7.88108 7.03165 7.93158C6.97833 7.98208 6.9153 8.02098 6.84647 8.04584C6.77764 8.07071 6.70448 8.08101 6.63153 8.07612C6.49441 8.06391 6.36692 7.99984 6.27458 7.89673C6.18225 7.79362 6.1319 7.65909 6.13361 7.52008V6.47869C6.1319 6.33969 6.18225 6.20516 6.27458 6.10205C6.36692 5.99894 6.49441 5.93487 6.63153 5.92266C6.70448 5.91777 6.77764 5.92807 6.84647 5.95294C6.9153 5.9778 6.97833 6.0167 7.03165 6.0672C7.08498 6.1177 7.12745 6.17874 7.15643 6.24652C7.18541 6.31429 7.20028 6.38736 7.20012 6.46119V7.53759Z"
                      fill="#F6F2E6" />
                  </svg>
                  {{ Product.property_developer }}
                </span>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="space-between">
          <v-col cols="12" md="8">
            <h6 class="agent-subtext">
              {{ t("$vuetify.real_estate_single.Product_details.responsible_agent") }}
            </h6>
            <v-row class=" ma-0">
              <v-card class="mt-4 card-agent" flat color="transparent" @click="GoToPartner(Product)">
                <v-img class="card-agent-img mr-1 mr-sm-2" cover :width="$vuetify.display.smAndUp ? '63px' : '45px'"
                  aspect-ratio="1" :src="urlAPI + Product.agent_image_path" :alt="Product.agent_image_alt"
                  :title="Product.agent_image_title"></v-img>
                <v-card-text class="card-agent-title pt-2 pb-1">
                  {{ $vuetify.locale.current == 'ru' ? Product['agent_ru'] : Product['agent_ro'] }}
                </v-card-text>
              </v-card>
            </v-row>
            <!--  @click="OpenContactUsModalActive(Product)" -->
            <v-row class="my-6">
              <v-col cols="auto" class="py-2">
                <v-btn :href="'tel:' + Product.agent_phone" variant="outlined"
                  class="btn-agent-1 rounded-pill px-8 px-sm-12">
                  <v-row justify="center" class="ma-0" style="padding-top: 1px;">
                    <svg width="15" height="15" class="mr-2" viewBox="0 0 15 15" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1.87559 10.3267V12.5252L0.229626 11.5599C0.0875559 11.4765 0 11.3223 0 11.1553V9.22662L1.87559 10.3267Z"
                        fill="#F6F2E6" />
                      <path d="M3.75031 11.4268L3.74969 13.6252L1.87559 12.5252V10.3267L3.75031 11.4268Z"
                        fill="#F6F2E6" />
                      <path
                        d="M5.62528 12.5252V14.1869C5.62528 14.4263 5.37087 14.5761 5.16712 14.4566L3.74969 13.6252L3.75031 11.4268L5.62528 12.5252Z"
                        fill="#F6F2E6" />
                      <path
                        d="M5.62528 10.3267V12.5252L3.75031 11.4268L3.74976 9.49601C3.74973 9.37626 3.877 9.30135 3.97889 9.36116L5.62248 10.3259C5.62333 10.3264 5.6243 10.3267 5.62528 10.3267Z"
                        fill="#F6F2E6" />
                      <path d="M1.87559 8.12659V10.3267L0 9.22662V7.02655L1.87559 8.12659Z" fill="#F6F2E6" />
                      <path d="M1.87516 5.92682L1.87559 8.12659L0 7.02655V4.82682L1.87516 5.92682Z" fill="#F6F2E6" />
                      <path d="M3.74819 4.828L1.87516 5.92682L0 4.82682L1.87559 3.72796L3.74819 4.828Z"
                        fill="#F6F2E6" />
                      <path
                        d="M5.62228 5.92803L3.75031 7.02682L3.44233 6.84676L1.87516 5.92682L3.74819 4.828H3.74969L5.62228 5.92803Z"
                        fill="#F6F2E6" />
                      <path
                        d="M7.26799 6.89325C7.37004 6.9531 7.37005 7.10305 7.26801 7.16292L5.8541 7.99235C5.71246 8.07544 5.53809 8.07544 5.39644 7.99236L3.75031 7.02682L5.62228 5.92803L7.26799 6.89325Z"
                        fill="#F6F2E6" />
                      <path
                        d="M11.2518 11.4568L11.249 13.4852C11.2489 13.5366 11.2489 13.5624 11.2416 13.5854C11.235 13.6067 11.2238 13.6262 11.2091 13.6428C11.193 13.6606 11.1712 13.6735 11.1274 13.6992L10.1033 14.3003C9.86678 14.4391 9.7485 14.5085 9.65143 14.4992C9.56301 14.4906 9.48262 14.4433 9.43118 14.3696C9.37472 14.2886 9.37472 14.1496 9.37472 13.8716V12.5279L11.2518 11.4568Z"
                        fill="#F6F2E6" />
                      <path d="M11.2518 9.25821L11.2518 11.4568L9.37772 12.5279V10.3247L11.2518 9.25821Z"
                        fill="#F6F2E6" />
                      <path d="M11.2488 7.02921L11.2518 9.25821L9.37772 10.3247L9.37472 8.12924L11.2488 7.02921Z"
                        fill="#F6F2E6" />
                      <path
                        d="M11.2488 7.02921L9.37472 8.12924L7.86235 7.24153C7.7448 7.17253 7.68602 7.13803 7.66567 7.09309C7.64713 7.05215 7.64694 7.00503 7.66515 6.96394C7.68513 6.91883 7.74363 6.88384 7.86062 6.81385L9.37772 5.90633L11.2488 7.02921Z"
                        fill="#F6F2E6" />
                      <path d="M13.1259 5.90632L11.2488 7.02921L9.37772 5.90633L11.219 4.8082L13.1259 5.90632Z"
                        fill="#F6F2E6" />
                      <path d="M15 4.8398L13.1259 5.90632L11.219 4.8082L13.1233 3.72796L15 4.8398Z" fill="#F6F2E6" />
                      <path d="M15 4.8398L14.9985 7.0292L13.1261 8.15908L13.1259 5.90632L15 4.8398Z" fill="#F6F2E6" />
                      <path
                        d="M14.9985 7.0292L14.9976 8.80491C14.9976 8.95732 14.9975 9.03353 14.9763 9.10203C14.9567 9.16523 14.9241 9.22346 14.8807 9.27285C14.8336 9.32636 14.7693 9.36523 14.6405 9.44297L13.1259 10.3583L13.1261 8.15908L14.9985 7.0292Z"
                        fill="#F6F2E6" />
                      <path d="M13.1261 8.15908L13.1259 10.3583L11.2518 11.4568L11.2518 9.25821L13.1261 8.15908Z"
                        fill="#F6F2E6" />
                      <path
                        d="M13.1229 3.728L11.219 4.8082L10.943 4.64673L9.37578 3.72678L11.2488 2.62796H11.2503L13.1229 3.728Z"
                        fill="#F6F2E6" />
                      <path d="M11.2477 2.628L9.37578 3.72678L7.50062 2.62796L9.37259 1.528L11.2477 2.628Z"
                        fill="#F6F2E6" />
                      <path
                        d="M9.37259 1.528L7.50062 2.62796L5.62547 1.52796L7.26952 0.562434C7.41124 0.479208 7.58577 0.479187 7.7275 0.562381L9.37259 1.528Z"
                        fill="#F6F2E6" />
                      <path
                        d="M1.87516 3.728L3.74712 4.82678L4.0551 4.64673L5.62228 3.72678L3.75 2.62398L1.87516 3.728Z"
                        fill="#F6F2E6" />
                      <path
                        d="M3.75 2.62398L5.62547 3.728L5.93345 3.54794L7.50062 2.62796L5.62547 1.52796L3.75 2.62398Z"
                        fill="#F6F2E6" />
                      <path
                        d="M5.625 10.1487V11.3784L3.49034 10.2117C3.41928 10.1729 3.375 10.0979 3.375 10.0163V8.82437L5.625 10.1487Z"
                        fill="#F6F2E6" />
                      <path
                        d="M5.625 10.1487V11.3784L3.49034 10.2117C3.41928 10.1729 3.375 10.0979 3.375 10.0163V8.82437L5.625 10.1487Z"
                        fill="#F6F2E6" />
                    </svg>
                    {{ t("$vuetify.real_estate_single.Product_details.btn_contact") }}
                  </v-row>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="py-2">
                <v-btn @click="OpenPdfModalActive(Product)" variant="flat"
                  class="btn-agent-2 rounded-pill px-8 px-sm-12">
                  <v-row justify="center" class="ma-0" style="padding-top: 1px;">
                    <svg width="14" height="15" class="mr-2" viewBox="0 0 14 15" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.608696 7.5H12.7826C12.944 7.5 13.0989 7.43415 13.213 7.31694C13.3272 7.19973 13.3913 7.04076 13.3913 6.875V5C13.3914 4.9179 13.3757 4.83659 13.3451 4.76072C13.3146 4.68485 13.2698 4.6159 13.2133 4.55781L8.95239 0.182813C8.89582 0.124791 8.82867 0.0787825 8.75478 0.0474149C8.68089 0.0160474 8.6017 -6.43662e-05 8.52174 1.93249e-07H1.21739C0.894519 1.93249e-07 0.584871 0.131696 0.356566 0.366117C0.12826 0.600537 0 0.91848 0 1.25V6.875C0 7.04076 0.0641304 7.19973 0.178283 7.31694C0.292435 7.43415 0.44726 7.5 0.608696 7.5ZM8.52174 1.5625L11.8696 5H8.52174V1.5625ZM14 10C14 10.1658 13.9359 10.3247 13.8217 10.4419C13.7076 10.5592 13.5527 10.625 13.3913 10.625H11.5652V11.875H12.7826C12.944 11.875 13.0989 11.9408 13.213 12.0581C13.3272 12.1753 13.3913 12.3342 13.3913 12.5C13.3913 12.6658 13.3272 12.8247 13.213 12.9419C13.0989 13.0592 12.944 13.125 12.7826 13.125H11.5652V14.375C11.5652 14.5408 11.5011 14.6997 11.3869 14.8169C11.2728 14.9342 11.118 15 10.9565 15C10.7951 15 10.6403 14.9342 10.5261 14.8169C10.412 14.6997 10.3478 14.5408 10.3478 14.375V10C10.3478 9.83424 10.412 9.67527 10.5261 9.55806C10.6403 9.44085 10.7951 9.375 10.9565 9.375H13.3913C13.5527 9.375 13.7076 9.44085 13.8217 9.55806C13.9359 9.67527 14 9.83424 14 10ZM1.82609 9.375H0.608696C0.44726 9.375 0.292435 9.44085 0.178283 9.55806C0.0641304 9.67527 0 9.83424 0 10V14.375C0 14.5408 0.0641304 14.6997 0.178283 14.8169C0.292435 14.9342 0.44726 15 0.608696 15C0.770132 15 0.924956 14.9342 1.03911 14.8169C1.15326 14.6997 1.21739 14.5408 1.21739 14.375V13.75H1.82609C2.39111 13.75 2.933 13.5195 3.33253 13.1093C3.73207 12.6991 3.95652 12.1427 3.95652 11.5625C3.95652 10.9823 3.73207 10.4259 3.33253 10.0157C2.933 9.60547 2.39111 9.375 1.82609 9.375ZM1.82609 12.5H1.21739V10.625H1.82609C2.06824 10.625 2.30048 10.7238 2.47171 10.8996C2.64294 11.0754 2.73913 11.3139 2.73913 11.5625C2.73913 11.8111 2.64294 12.0496 2.47171 12.2254C2.30048 12.4012 2.06824 12.5 1.82609 12.5ZM6.69565 9.375H5.47826C5.31682 9.375 5.162 9.44085 5.04785 9.55806C4.9337 9.67527 4.86957 9.83424 4.86957 10V14.375C4.86957 14.5408 4.9337 14.6997 5.04785 14.8169C5.162 14.9342 5.31682 15 5.47826 15H6.69565C7.42211 15 8.11882 14.7037 8.63251 14.1762C9.1462 13.6488 9.43478 12.9334 9.43478 12.1875C9.43478 11.4416 9.1462 10.7262 8.63251 10.1988C8.11882 9.67132 7.42211 9.375 6.69565 9.375ZM6.69565 13.75H6.08696V10.625H6.69565C7.09924 10.625 7.4863 10.7896 7.77168 11.0826C8.05707 11.3757 8.21739 11.7731 8.21739 12.1875C8.21739 12.6019 8.05707 12.9993 7.77168 13.2924C7.4863 13.5854 7.09924 13.75 6.69565 13.75Z"
                        fill="#111213" />
                    </svg>
                    {{ t("$vuetify.real_estate_single.Product_details.btn_see_presentation") }}
                  </v-row>
                </v-btn>
              </v-col>
            </v-row>
            <h6 class="Highlights-subtext mt-4">
              {{ t("$vuetify.real_estate_single.Product_details.highlights") }}
            </h6>
            <v-row class="mt-3" v-if="Product[`features_${$vuetify.locale.current}`]">
              <v-col cols="12" sm="auto" class="pa-2"
                v-for="(highlight, index) in Product[`features_${$vuetify.locale.current}`].split('$$$')" :key="index">
                <div class="div-highlights px-5" elevation="0">
                  <v-icon class="mr-2" color="#F6F2E6">mdi-star</v-icon>
                  {{ highlight }}
                </div>
              </v-col>
            </v-row>

            <h6 class="About-subtext mt-12 mb-4">
              {{ t("$vuetify.real_estate_single.Product_details.about_product") }}
            </h6>
            <span class="about-text">
              {{ Product[`description_${$vuetify.locale.current}`] }}
            </span>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PdfPresentation from "../Modals/PdfPresentation.vue";
import ContactUsModal from "../Modals/ContactUsModal.vue";
import { useLocale } from "vuetify";
import { mapGetters } from 'vuex'
import { urlAPI } from "../../store/config";

export default {
  name: "ProductDetails",
  props: {
    Product: Object,
    Categorie: Object,
  },
  components: {
    PdfPresentation,
    ContactUsModal,
  },
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  data: () => ({
    urlAPI: urlAPI + '/',
    btn: true
  }),
  mounted() {
    this.$store.dispatch("Load_price_type");
  },
  computed: {
    ...mapGetters([
      'get_price_type',
    ]),
  },
  methods: {
    GoToPartner(product) {
      this.$router.push({
        name: "partner-single",
        params: {
          lang: this.$vuetify.locale.current,
          name: product.agent_ro
        }
      })
    },
    OpenPdfModalActive(property) {
      this.$refs.OpenPdfModal.dialog = true;
      this.$refs.OpenPdfModal.property = property;
    },
    OpenContactUsModalActive(property) {
      this.$refs.OpenContactUsModal.dialog = true;
      this.$refs.OpenContactUsModal.property = property;
    }
  }
};
</script>

<style scoped>
.building-text {
  color: #9A9A9B;
  font-size: 1.1rem;
  letter-spacing: -0.02rem;
}

.building-subtext {
  color: #9A9A9B;
  font-size: 1.1rem;
}

.card-price-details {
  border-radius: 5px;
}

.location-text {
  font-size: 1rem;
  text-align: end;
  color: #9A9A9B;
  font-weight: 400;
}

.price-text {
  font-size: 2.2rem;
  color: #9A9A9B;
  font-weight: 400;
  white-space: nowrap;
  text-wrap: nowrap;
}

.price-text-small {
  font-size: 1.7rem;
}

.price-text-3 {
  font-size: 1.15rem;
  color: #9A9A9B;
  font-weight: 400;
}

.price-subtext {
  font-size: 1.1rem;
  color: #9A9A9B;
  font-weight: 400;
}

.about-text {
  color: #9A9A9B;
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 1.7rem;
}

.div-highlights {
  background: #191919;
  color: #9A9A9B;
  font-size: 1rem;
  text-transform: inherit;
  letter-spacing: -0.002rem;
  align-items: center;
  border-radius: 40px;
  min-height: 36px;
  min-width: 64px;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.About-subtext {
  color: #9A9A9B;
  font-size: 1.1rem;
  font-weight: 400;
}

.Highlights-subtext {
  color: #9A9A9B;
  font-size: 1.1rem;
  font-weight: 400;
}

.btn-agent-2 {
  color: #111213;
  text-transform: inherit;
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: -0.03rem;
  transition: 0.7s;
}

.btn-agent-2:hover {
  color: #111213;
  background: #f6f2e6;
}

.btn-agent-1 {
  color: rgba(246, 242, 230, 1);
  text-transform: inherit;
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: -0.03rem;
  transition: 0.7s;
  align-items: center;
}

.btn-agent-1 svg {
  margin-bottom: 1px;
}

.btn-agent-1 svg path {
  transition: 0.7s;
}

.btn-agent-1:hover svg path {
  fill: #111213;
}

.btn-agent-1:hover {
  color: #111213;
  background: #f6f2e6;
}

.card-agent {
  display: flex;
  align-items: center;
}

.card-agent-img {
  border-radius: 100%;
  border: 1px solid #19D442;
}

.card-agent-title {
  color: #F6F2E6;
  font-size: 3rem;
  letter-spacing: -0.02rem;
  font-weight: 400;
  line-height: 3rem;
}

.agent-subtext {
  color: #9A9A9B;
  font-size: 1.1rem;
  font-weight: 400;
}

.product-title-text {
  color: #F6F2E6;
  font-weight: 500;
  font-size: 3rem;
  line-height: 3.7rem;
  letter-spacing: -0.04rem;
  text-wrap: pretty;
}

.categorie-text {
  color: #9A9A9B;
  font-size: 1.1rem;
  font-weight: 400;
}

@media screen and (max-width: 600px) {
  .div-highlights {
    background: transparent;
  }

  .product-title-text {
    font-size: 2.5rem;
    line-height: 3.2rem;
  }

  .btn-agent-1,
  .btn-agent-2 {
    font-size: 1rem;
    zoom: .8;
  }

  .card-agent-title {
    font-size: 1.8rem;
    line-height: 3rem;
  }

  .building-text {
    font-size: 1rem;
  }

  .building-subtext {
    font-size: 1rem;
  }

  .location-text {
    font-size: 1rem;
  }

  .price-text {
    font-size: 2rem;
  }
}

@media screen and (min-width: 600px) and (max-width: 960px) {}
</style>